import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogContent, EnhancedTable, Stack } from '@monorepo/nova-ui';
import type { MidnightValue } from '@monorepo/types';
import { useMidnightTableColumns } from '../hooks/use-midnight-table-columns';
import { useMidnightTableConfig } from '../hooks/use-midnight-table-config';
import { MidnightEmptyState } from './midnight-empty-state';
import { MidnightErrorState } from './midnight-error-state';
import { MidnightLoadingState } from './midnight-loading-state';

interface MidnightModalContentProps {
  midnightValues?: MidnightValue[];
  isLoading: boolean;
  error?: Error | string | unknown;
  onRetry: () => void;
}

export const MidnightModalContent: FC<MidnightModalContentProps> = ({
  midnightValues,
  isLoading,
  error,
  onRetry,
}) => {
  const { t } = useTranslation(['dashboardTemplates']);
  const columns = useMidnightTableColumns();
  const { sortingConfig, getRowId, stableServerDataFetcher } =
    useMidnightTableConfig();

  return (
    <DialogContent>
      <Stack sx={{ minHeight: 200 }}>
        {isLoading ? (
          <MidnightLoadingState />
        ) : error ? (
          <MidnightErrorState error={error} onRetry={onRetry} />
        ) : !midnightValues || midnightValues.length === 0 ? (
          <MidnightEmptyState />
        ) : (
          <EnhancedTable
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            columns={columns as any}
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            rows={midnightValues as any}
            getRowId={getRowId}
            stickyHeader
            dense
            isLoading={isLoading}
            serverSide={false}
            serverDataFetcher={stableServerDataFetcher}
            sorting={sortingConfig}
            containerProps={{
              sx: {
                maxHeight: 400,
                overflow: 'auto',
              },
            }}
            aria-label={t('dashboardTemplates:midnight_values_last_60_days')}
          />
        )}
      </Stack>
    </DialogContent>
  );
};
